import {
  SET_WEB_SOCKET_CHANEL_REQUEST,
  SET_WEB_SOCKET_CHANEL_SUCCESS,
} from "./constant";

const getWebSocketChanelReducers = (state = { data: {} }, action) => {
  switch (action.type) {
    case SET_WEB_SOCKET_CHANEL_REQUEST:
      return { loading: true };
    case SET_WEB_SOCKET_CHANEL_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    default:
      return state;
  }
};

const webSocketReducers = {
  getWebSocketChanel: getWebSocketChanelReducers,
};

export default webSocketReducers;
